export default __webpack_public_path__ + "static/media/stephanie.f9ba431d.png";